import { render, staticRenderFns } from "./DispatchItem.vue?vue&type=template&id=1f4d1182"
import script from "./DispatchItem.vue?vue&type=script&lang=js"
export * from "./DispatchItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports